import eventHub from '@/scripts/eventHub';
import gsap from 'gsap';
import { random } from 'lodash';
import {
  AnimatedSprite,
  Container,
  Loader,
  Point,
  Sprite,
} from 'pixi.js';
import state from '../state';
import vars from '../vars';
import Actor from './Actor';

class Pipe extends Actor {
  constructor(parent, forced = false) {
    super(parent);

    this.n = -1;
    this.forced = forced;
    this.position = '';
    this.registered = false;

    this.position = state.previousPosition === 'bottom' ? 'up' : 'bottom';
    state.previousPosition = this.position;
    let n;
    if (this.position === 'up') {
      n = random(1, 8, false);
      this.n = n;
      this.obstacle = new Sprite(Loader.shared.resources[`textures/OBSTACLE_${n}`].texture);
      this.shadow = new Sprite(Loader.shared.resources[`textures/OBSTACLE_SHADOW_${n}`].texture);
      this.sprite = new Container();
    } else {
      n = !this.forced ? random(9, 19, false) : 17;
      this.n = n;
      if (n <= 16) {
        this.obstacle = new Sprite(
          Loader.shared.resources[`textures/OBSTACLE_${this.obstaclePath}`].texture,
        );
        this.shadow = new Sprite(
          Loader.shared.resources[`textures/OBSTACLE_SHADOW_${this.obstaclePath}`].texture,
        );
        this.sprite = new Container();
      } else {
        this.obstacle = new Sprite(Loader.shared.resources[`textures/OBSTACLE_${n}`].texture);
        this.face = new AnimatedSprite(
          Object.values(Loader.shared.resources[`sprites/OBSTACLE_FACE_${n}`].spritesheet.textures),
        );
        this.face.animationSpeed = 0.5;
        this.face.loop = true;
        this.face.play();
        this.shadow = new Sprite();
        this.sprite = new Container();
      }
    }

    this.sprite.addChild(this.shadow);
    this.sprite.addChild(this.obstacle);
    if (this.face) {
      this.sprite.addChild(this.face);
    }

    this.resize(n);
    this.parent.addChild(this.sprite);
  }

  resize(n) {
    this.obstacle.anchor = this.position === 'up' ? new Point(0.5, 0.1) : new Point(0.5, 1);
    this.shadow.anchor = this.position === 'up' ? new Point(0.5, 0.1) : new Point(0.5, 1);
    if (this.face) {
      this.face.anchor = this.position === 'up' ? new Point(0.5, 0) : new Point(0.5, 1);
      this.face.position.y -= n === 19 ? 220 : 200;
    }

    this.sprite.position.x = !this.forced ? vars.layout.FRAME_WIDTH + (this.sprite.width / 2) : vars.layout.FRAME_WIDTH + 10;
    this.sprite.position.y = this.position === 'up' ? 0 : vars.layout.FRAME_HEIGHT;

    // Spawn the coin, if you are lucky
    const spawnProbability = 0.4;
    if (random(0, 1, true) <= spawnProbability) {
      const yDistance = 40 * random(1, 3, true);
      const typeProbability = random(0, 1, true);
      const type = typeProbability < 0.8 ? 'seed' : (typeProbability >= 0.8 && typeProbability <= 0.9 ? 'light' : 'heavy'); // eslint-disable-line
      eventHub.$emit('spawncoin', {
        x: this.sprite.width / 2,
        y: this.position === 'up' ? this.sprite.height + yDistance : vars.layout.FRAME_HEIGHT - (this.sprite.height + yDistance),
        type,
      });
    }
  }

  out() {
    return gsap.to(this.sprite, {
      y: this.position === 'up' ? `-=${this.sprite.height}` : `+=${this.sprite.height}`,
      duration: 0.8,
      ease: 'back.in(1.7)',
    });
  }

  destroy() {
    this.sprite.destroy();
  }

  get obstaclePath() {
    return `${this.n}${state.level > 2 && [10, 13, 15].includes(this.n) ? '_TALL' : ''}`;
  }
}

export default Pipe;
